import Collection from '@/api/collection.api.js'

/*eslint-disable */
export const getCollections = ({ commit }, data) => {
  return Collection.getCollections(data)
    .then(response => {
      commit("SET_COLLECTIONS", response.data)
      const templates = response.data.reduce((prev, collection) => prev.concat(collection.templates), [])
      commit("SET_TEMPLATES", templates)
      return response.data;
    })
}

export const createCollection = ({ commit }, data) => {
  return Collection.createCollection(data)
    .then(response => {
      return response.data;
    })
}

export const setCollection = ({ commit }, data) => {
  commit("SET_COLLECTION", data);
}
/*eslint-enable */
